export default __webpack_public_path__ + "static/media/i_bus-tro_gn.e2c32d35.svg";